import styled from "styled-components";

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: rgb(202, 202, 202);
  border-radius: 5px;
  padding: 0 10px;
  width: 100%;
`;

export const InputField = styled.input`
  flex: 1;
  outline: none;
  border: none;
  padding: 16px 10px;
  font-size: 16px;
  background-color: transparent;
`;

export const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(80, 80, 80);

  &:hover {
    opacity: 0.7;
  }
`;
